import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

const PortableDesign: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('PortableDesign');

    const swiperRef = useRef<any>(null);

    const imgage1PC = ['us', 'ca', 'ph'].includes(locale)
        ? 'https://websiteoss.ecoflow.com/upload/image/1753682741210/pc-1.jpg'
        : 'https://websiteoss.ecoflow.com/figma-uploads/1756782707039-vgo0ay-compressed-300_16%201.jpg';
    const imgage1Pad = ['us', 'ca', 'ph'].includes(locale)
        ? 'https://websiteoss.ecoflow.com/upload/image/1753682739700/pad-1.jpg'
        : 'https://websiteoss.ecoflow.com/figma-uploads/1756782740770-z8qk89-compressed-300_16%201.jpg';
    const imgage1H5 = ['us', 'ca', 'ph'].includes(locale)
        ? 'https://websiteoss.ecoflow.com/upload/image/1753682740947/h5-1.jpg'
        : 'https://websiteoss.ecoflow.com/figma-uploads/1756782777038-sfus5h-compressed-300_16%201.jpg';

    const imgage2PC = 'https://websiteoss.ecoflow.com/upload/image/1753682741487/pc-2.jpg';
    const imgage2Pad = 'https://websiteoss.ecoflow.com/upload/image/1753682740237/pad-2.jpg';
    const imgage2H5 = 'https://websiteoss.ecoflow.com/upload/image/1753682739985/h5-2.jpg';

    const imgage3PC = 'https://websiteoss.ecoflow.com/upload/image/1753682740458/pc-3.jpg';
    const imgage3Pad = 'https://websiteoss.ecoflow.com/upload/image/1753682741753/pad-3.jpg';
    const imgage3H5 = 'https://websiteoss.ecoflow.com/upload/image/1753682740720/h5-3.jpg';

    const items = [
        {
            title: t('item1_title'),
            desc: t('item1_desc'),
            pc: imgage1PC,
            pad: imgage1Pad,
            h5: imgage1H5,
        },
        {
            title: t('item2_title'),
            desc: t('item2_desc'),
            pc: imgage2PC,
            pad: imgage2Pad,
            h5: imgage2H5,
        },
        {
            title: t('item3_title'),
            desc: t('item3_desc'),
            pc: imgage3PC,
            pad: imgage3Pad,
            h5: imgage3H5,
        },
    ];

    const [activeIndex, setActiveIndex] = useState(0);

    const onmouseenter = (target: any, index: number) => {
        setActiveIndex(index);
    };

    return (
        <div className={`${styles.PortableDesign} GtmModuleData-section`} data-section-id="PortableDesign" id="PortableDesign">
            <EcoSectionCommon title={t('title')} desc={t('desc')} />

            <div className="trail-layout box">
                {items.map((item, index) => (
                    <div className={'item ' + (index === activeIndex ? 'active' : '')} key={index} onMouseEnter={(e) => onmouseenter(e.currentTarget, index)}>
                        <div className="content">
                            <div className="title">{item.title}</div>
                            <div className="desc">{item.desc}</div>
                        </div>
                        <EcoImg pc={item.pc} pad={item.pad} h5={item.h5} />
                    </div>
                ))}
            </div>

            <div className="trail-layout pad-only">
                <Swiper
                    onSwiper={(swiper) => {
                        swiperRef.current = swiper;
                    }}
                    slidesPerView={'auto'}
                    spaceBetween={12}
                    // modules={[Navigation]}
                    // navigation={{
                    //     nextEl: '.swiper-button-next',
                    //     prevEl: '.swiper-button-prev',
                    // }}
                    initialSlide={0}
                >
                    {items.map((item, index) => (
                        <SwiperSlide key={index} className="list-item">
                            <EcoImg pc={item.pc} pad={item.pad} h5={item.h5} />
                            <div className="title">{item.title}</div>
                        </SwiperSlide>
                    ))}
                    {/* <div className="swiper-button-prev" onClick={handlePrev} />
                    <div className="swiper-button-next" onClick={handleNext} /> */}
                </Swiper>
            </div>

            <div className="trail-layout footer-desc">{t('footer_desc')}</div>
        </div>
    );
};

export default PortableDesign;
